import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { useAuctionPricing } from 'dibs-auctions/exports/hooks';
import classnames from 'classnames';
import { FormattedMessage } from 'dibs-react-intl';

import { PdpSharedAuctionTooltipLazy } from '../../PdpSharedAuctionToolTip/PdpSharedAuctionTooltipLazy';
import {
    OriginalListPrice,
    AUCTION_SALE_TREATMENT_VARIANT_KEY,
} from 'dibs-auctions/exports/OriginalListPrice';

// types
import { PdpSharedOriginalPriceWithReserveStatusVariant_item$key as Item } from './__generated__/PdpSharedOriginalPriceWithReserveStatusVariant_item.graphql';

import dibsCss from 'dibs-css';

const itemFragment = graphql`
    fragment PdpSharedOriginalPriceWithReserveStatusVariant_item on Item {
        ...useAuctionPricing_item @arguments(page: pdp)
        ...OriginalListPrice_item
    }
`;

export const PdpSharedOriginalPriceWithReserveStatusVariant: FC<{
    item: Item;
    currency: string;
}> = ({ item: itemRef, currency }) => {
    const item = useFragment(itemFragment, itemRef);
    const { hasReserve } = useAuctionPricing({
        item,
        currency,
    });

    return (
        <div className={classnames(dibsCss.sassyFontBodySmall, dibsCss.inline)}>
            <OriginalListPrice
                type={AUCTION_SALE_TREATMENT_VARIANT_KEY}
                item={item}
                currency={currency}
                className={dibsCss.inline}
                includeSpacer={!hasReserve}
            />

            {!hasReserve && (
                <span className={classnames(dibsCss.inlineBlock)}>
                    <FormattedMessage
                        id="PdpSharedOriginalPriceWithReserveStatusVariant.noReserve"
                        defaultMessage="No Reserve"
                    />
                    <PdpSharedAuctionTooltipLazy type="reserve" size="small" />
                </span>
            )}
        </div>
    );
};
